var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIncrease(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "40px",
    viewBox: "0 0 74 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icIncrease") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extend-your-boost",
    transform: "translate(-92.000000, -259.000000)",
    fill: "#FF5172",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(34.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.805532,47.2499996 C127.593387,47.2499996 128.353102,47.5655874 128.902051,48.1266899 C129.453363,48.6901633 129.761844,49.4501454 129.750029,50.2386661 L129.540928,64.0436322 L125.097555,61.35079 C124.628697,60.874606 123.981713,60.6079159 123.312476,60.6079159 C122.646036,60.6079159 122.001627,60.8741082 121.53095,61.3472255 L100.833754,82.0466367 C100.313013,82.5572863 99.6086714,82.8522457 98.8698724,82.8522457 C98.1317249,82.8522457 97.4318035,82.5640047 96.9121478,82.0483801 L88.1893762,73.3234103 C87.5525689,72.686603 86.7170003,72.3681297 85.8810985,72.3681297 C85.0453163,72.3681297 84.2092515,72.6865212 83.5711843,73.3233981 L67.5750801,89.3173072 C67.0964391,89.7919428 66.4495428,90.0581863 65.7726663,90.0581863 C65.0960806,90.0581863 64.4494401,89.7920952 63.9708661,89.3135212 L60.9948898,86.3419421 C60.4982507,85.8433005 60.25,85.1899423 60.25,84.5366192 C60.25,83.8832961 60.4982507,83.2299378 60.9944839,82.7317028 L84.0830013,59.6563751 C84.5614967,59.1778797 85.2101791,58.9096424 85.886869,58.9096424 C86.5635068,58.9096424 87.2100951,59.1779318 87.6885385,59.6563751 L96.5668708,68.534706 C97.202668,69.1740752 98.0378909,69.4937798 98.8737194,69.4937798 C99.7093088,69.4937798 100.545524,69.174239 101.183329,68.5352442 L114.943202,54.7819555 C115.4242,54.3082817 115.68826,53.6637922 115.68826,52.9946915 C115.68826,52.3236928 115.417786,51.6817608 114.942293,51.2087069 L112.232586,48.5012002 Z",
    id: "icIncrease",
    transform: "translate(95.000000, 68.654093) rotate(5.000000) translate(-95.000000, -68.654093) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncrease);
export default __webpack_public_path__ + "static/media/icIncrease.837d1e8062f461db7e9540a310fe96c3.svg";
export { ForwardRef as ReactComponent };